<template>
  <header class="main-header-container">
    <div class="main-header-content">
      <div class="logo-container">
        <logo/>
      </div>
      <icon-default
          :size="'big'"
          @click="changeStateMenu"
          :color="activeMenu ? 'white' : 'light'">
        <icon-menu/>
      </icon-default>
    </div>
    <transition name="fade-translate-y-card-revert">
      <div class="menu-burger-container" v-if="activeMenu">
        <div :class="['menu-content-wrapper']">
          <navigation-title v-for="(item, index) in navigationInfo"
                            @click="activeMenu = false"
                            :key="index"
                            :item="item"/>
          <navigation-title
              class="exit-title"
              @click="logout()"
              :item="exitInfo"/>
        </div>
      </div>
    </transition>
  </header>
</template>

<script>
import logo from '@/assets/logo/logo.svg?inline'
import IconDefault from "@/components/shared/icons/IconDefault.vue";
import IconMenu from "@/assets/icons/menu/menu.svg?inline"
import navigation from "@/static/data/navigation";
import BigTitle from "@/components/shared/text/BigTitle.vue";
import exitIcon from '@/assets/icons/menu/exit.svg?inline'
import NavigationTitle from "@/components/widgets/NavigationTitle.vue";


export default {
  name: "MenuMobile",
  components: {
    NavigationTitle,
    BigTitle, IconDefault, IconMenu, exitIcon, logo},
  mixins: [navigation],
  data() {
    return {
      activeMenu: false
    }
  },

  methods: {
    changeStateMenu() {
      this.activeMenu = !this.activeMenu
    },
  },
  computed: {
    exitInfo() {
      return {
        id: 7,
        text: 'Выйти',
        icon: exitIcon
      }
    }
  }
}
</script>

<style scoped lang="scss">
.main-header-container {
  z-index: 950;
  position: fixed;
  top: 0;
  width: 100%;
  .logo-container {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 15px;
  }
  .main-header-content {
    padding: 12px 16px;
    position: relative;
    z-index: 901;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 100%;
    background: var(--color-dark-green);
  }

  .menu-burger-container {
    padding: 72px 16px 24px;
    backdrop-filter: blur(20px);
    z-index: 900;
    position: absolute;
    width: var(--calc-width);
    height: var(--calc-height);
    top: 0;
    left: 0;
    background-color:  var(--color-dark-green);
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .menu-content-wrapper {
      height: 100%;
      display: flex;
      flex-direction: column;
      row-gap: 24px;


      .exit-title {
        margin-top: auto;
      }
    }
  }
}

</style>